export enum RecommendationType {
  FrequentlyBoughtTogether = 0,
  RelatedProducts = 1,
  TrendingItems = 2,
  TrendingFacets = 3,
  LookingSimilar = 4,
}
